import React, { useContext } from 'react';
import { FooterBase } from '../../components/FooterBase';
import { MenuContext } from '../../helpers/MenuHelpers';

export const Footer = () => {
  const { wordpress } = useContext(MenuContext);

  return <FooterBase data={wordpress.footer} />;
};
